import { FC } from 'react';
import SectionHead from '../../SectionHead';
import CompanyInfoForm from '../CompanyInfoForm';

const SupplierCompany: FC = () => {
  return (
    <>
      <SectionHead>排出事業者情報</SectionHead>
      <CompanyInfoForm namePrefix={'supplierCompanyInfo'} />
    </>
  );
};
export default SupplierCompany;
